import { useEffect } from 'react';
import { useFormState } from 'shared';

export function useOperatorForm(operator, onChangeInput) {
  const [operatorInputs, setOperatorInputs] = useFormState(operator, onChangeInput);

  useEffect(() => {
    setOperatorInputs({ ...operator }, false);
  }, [operator]);

  const handleChange =
    fieldName =>
    ({ target }) => {
      setOperatorInputs(inputs => ({ ...inputs, [fieldName]: target.value }));
    };

  return {
    operatorInputs,
    handleChange
  };
}
